// import { getLodop } from "./LodopFuncs";
let LODOP = getLodop();
// 正本 297 420 A3
// 副本 210 297 A4
// 正本打印
function printZBEvt(data, qrcode) {
  // LODOP.ADD_PRINT_TEXT("10mm","10mm","45mm","30mm",data.zbSize);
  LODOP.ADD_PRINT_TEXT("88mm", "39mm", "60mm", "30mm", "统一社会信用代码");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

  LODOP.ADD_PRINT_TEXT("98mm", "39mm", "120mm", "30mm", `${data.uniscid}`);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);

  // LODOP.ADD_PRINT_IMAGE("89mm", "320mm", "25mm", "25mm", qrcode);
  // LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);

  LODOP.ADD_PRINT_TEXT("88.5mm", "350mm", "31mm", "25mm", "扫描市场主体身份码了解更多登记、备案、许可、监管信息，体验更多应用服务。");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);

  LODOP.ADD_PRINT_TEXT("246mm", "305mm", "20mm", "10.5mm", `${data.Y}`);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 20);
  LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

  LODOP.ADD_PRINT_TEXT("246mm", "332mm", "15mm", "10.5mm", `${data.M}`);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 20);
  LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

  LODOP.ADD_PRINT_TEXT("246mm", "350mm", "15mm", "10.5mm", `${data.D}`);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 20);
  LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

  LODOP.ADD_PRINT_TEXT("276mm", "79mm", "60mm", "30mm", "http://www.gsxt.gov.cn");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "方正书宋简体");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

  //  LODOP.PRINT_DESIGN();
  // LODOP.PREVIEW();
  // LODOP.SET_PRINTER_INDEX("HP5200");
  // LODOP.SET_PRINTER_INDEX("HP-LaserJet-5200");
  LODOP.SET_PRINTER_INDEX("yyzzzb");
  LODOP.PRINT();
}
function printFBEvt(data, qrcode) {
  LODOP.ADD_PRINT_TEXT("50mm", "29mm", "45mm", "30mm", "统一社会信用代码");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

  LODOP.ADD_PRINT_TEXT("57.5mm", "29mm", "120mm", "20mm", `${data.uniscid}`);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

  // LODOP.ADD_PRINT_IMAGE("50.5mm", "213mm", "21mm", "21mm", qrcode);
  // LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);


  LODOP.ADD_PRINT_TEXT("167mm", "211mm", "20mm", "10.5mm", `${data.Y}`);
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
  LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");


  LODOP.ADD_PRINT_TEXT("167mm", "233mm", "11mm", "10.5mm", `${data.M}`);
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
  LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");


  LODOP.ADD_PRINT_TEXT("167mm", "246mm", "11mm", "10.5mm", `${data.D}`);
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
  LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");


  LODOP.ADD_PRINT_TEXT("51mm", "237.5mm", "21mm", "25mm", "扫描市场主体身份码了解更多登记、备案、许可、监管信息，体验更多应用服务。");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
  LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.26mm");

  LODOP.ADD_PRINT_TEXT("191mm", "62mm", "60mm", "20mm", "http://www.gsxt.gov.cn");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "方正书宋简体");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);

  // LODOP.ADD_PRINT_TEXT("191.20mm", "137mm", "31.95mm", "5mm", "市场主体应当于每年");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.ADD_PRINT_TEXT("191.20mm", "166.05mm", "2.7mm", "5mm", "1");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  // LODOP.ADD_PRINT_TEXT("191.20mm", "169.39mm", "2.7mm", "5mm", "月");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  // LODOP.ADD_PRINT_TEXT("191.20mm", "172.51mm", "2.7mm", "5mm", "1");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  // LODOP.ADD_PRINT_TEXT("191.20mm", "175.37mm", "9.05mm", "5mm", "日至");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.ADD_PRINT_TEXT("191.20mm", "181.93mm", "2.7mm", "5mm", "6");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  // LODOP.ADD_PRINT_TEXT("191.20mm", "185.05mm", "2.7mm", "5mm", "月");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  // LODOP.ADD_PRINT_TEXT("191.20mm", "186.58mm", "6.14mm", "5mm", "30");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  // LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
  // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "0.1mm");
  // LODOP.ADD_PRINT_TEXT("191.20mm", "190.77mm", "13.29mm", "5mm", "日通过国");
  // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.ADD_PRINT_TEXT("191.20mm", "137mm", "93.29mm", "15mm", "市场主体应当于每年1月1日至6月30日通过国");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.ADD_PRINT_TEXT("195mm", "137mm", "65.95mm", "30mm", "家企业信用信息公示系统报送公示年度报告。");
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.ADD_PRINT_TEXT("68.5mm", "172mm", "60mm", "20mm", `1-1`);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
  // LODOP.PRINT_DESIGN();
  // LODOP.PREVIEW();
  // LODOP.SET_PRINTER_INDEX("HP520002");
  // LODOP.SET_PRINTER_INDEX("Lenovo-LJ2405-2");
  // LODOP.SET_PRINTER_INDEX("Lenovo-LJ2405");
  LODOP.SET_PRINTER_INDEX("yyzzfb");
  LODOP.PRINT();
}
function ZBTITLE(content, top, left) {
  top = top - 2
  var count = content.length;
  var title = content.split('')
  if (count == 6) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "40mm", "30mm", content);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
    return
  }
  LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "40mm", "30mm", title[0]);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

  if (count == 2) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 33}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
  if (count == 3) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 17}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 33}mm`, "40mm", "30mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
  if (count == 4) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 11}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 22}mm`, "40mm", "30mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 33}mm`, "40mm", "30mm", title[3]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
  if (count == 5) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 8.5}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 17}mm`, "40mm", "30mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 25.5}mm`, "40mm", "30mm", title[3]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 33}mm`, "40mm", "30mm", title[4]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
}
function ZBTLONEITLE(content, top, left) {
  top = top - 2
  var count = content.length;
  var title = content.split('')
  if (count == 7) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "460mm", "30mm", content);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
    return
  }
  LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "40mm", "30mm", title[0]);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

  if (count == 2) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 39}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
  //  if (count == 3) {
  //  LODOP.ADD_PRINT_TEXT(`${top}mm`,`${left+17}mm`,"40mm","30mm",title[1]);
  //  LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪中黑");
  //  LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

  //  LODOP.ADD_PRINT_TEXT(`${top}mm`,`${left+33}mm`,"40mm","30mm",title[2]);
  //  LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪中黑");
  //  LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  // }
  if (count == 4) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 13}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 26}mm`, "40mm", "30mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 39}mm`, "40mm", "30mm", title[3]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
  if (count == 5) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 8.5}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 17}mm`, "40mm", "30mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 25.5}mm`, "40mm", "30mm", title[3]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 33}mm`, "40mm", "30mm", title[4]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
  if (count == 6) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 7.8}mm`, "40mm", "30mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 15.6}mm`, "40mm", "30mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 23.4}mm`, "40mm", "30mm", title[3]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 31.2}mm`, "40mm", "30mm", title[4]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 39}mm`, "40mm", "30mm", title[5]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
  }
}
function FBTITLE(content, top, left) {
  top = top - 2.2
  var count = content.length;
  if (count == 5) {
    // LODOP.ADD_PRINT_TEXT(`${top}mm`,"29mm","30mm","20mm",content);
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "30mm", "20mm", content);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    return
  }
  var title = content.split('')

  if (count == 6) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "5mm", "20mm", title[0]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 4}mm`, "6mm", "20mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 8}mm`, "6mm", "20mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 12}mm`, "6mm", "20mm", title[3]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 16}mm`, "6mm", "20mm", title[4]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 20}mm`, "6mm", "20mm", title[5]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

    return
  }
  if (count == 7) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "30mm", "20mm", content);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    return
  }
  LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, "5mm", "20mm", title[0]);
  LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
  LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);

  if (count == 2) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 20}mm`, "6mm", "20mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
  }
  if (count == 3) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 9.5}mm`, "6mm", "20mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 20}mm`, "6mm", "20mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
  }
  if (count == 4) {
    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 7}mm`, "6mm", "20mm", title[1]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 13}mm`, "24.5mm", "20mm", title[2]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);

    LODOP.ADD_PRINT_TEXT(`${top}mm`, `${left + 20}mm`, "24.5mm", "20mm", title[3]);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
  }
}
var lodop = {
  // 企业营业执照正本
  YYZZZB1: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)
    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");


    ZBTITLE("注册资本", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("成立日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("法定代表人", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    // ZBTITLE("营业期限",158,233)

    // LODOP.ADD_PRINT_TEXT("158mm","276mm","136mm","30mm",`${data.jyqx}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    ZBTITLE("住所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("经营范围", 170, 39)

    LODOP.ADD_PRINT_TEXT("170mm", "82mm", "135mm", "120mm", `${data.opscope}`);
    // LODOP.ADD_PRINT_TEXT("170mm","82mm","135mm","94mm",`${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }
    // 700字 7磅 
    // 超过700去窗口提示
    printZBEvt(data, qrcode)
  },
  // 企业营业执照副本
  YYZZFB1: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("注册资本", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)
    // LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.estdate}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("法定代表人", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    // FBTITLE("营业期限",105,164.5)

    // LODOP.ADD_PRINT_TEXT("105mm","193mm","90mm","40mm",`${data.jyqx}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    FBTITLE("住所", 105, 164.5)
    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "98mm", "100mm", `${data.opscope}`);
    // LODOP.ADD_PRINT_TEXT("115mm","58mm","98mm","65mm",`${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }
    printFBEvt(data, qrcode)
  },
  // 非公司企业法人营业执照正本
  YYZZZB2: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("出资额", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("成立日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("法定代表人", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    // ZBTITLE("经营期限",158,233)

    // LODOP.ADD_PRINT_TEXT("158mm","276mm","136mm","30mm",`${data.jyqx}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    ZBTITLE("住所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("经营范围", 170, 39)

    LODOP.ADD_PRINT_TEXT("170mm", "82mm", "130mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }

    // ZBTITLE("住所",170,233)

    // LODOP.ADD_PRINT_TEXT("170mm","276mm","110.5mm","100mm",`${data.dom}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-2.32mm");

    printZBEvt(data, qrcode)
  },
  // 非公司企业法人营业执照副本
  YYZZFB2: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("出资额", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)

    // LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.estdate}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("法定代表人", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    // FBTITLE("经营期限",105,164.5)

    // LODOP.ADD_PRINT_TEXT("105mm","193mm","90mm","40mm",`${data.jyqx}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("住所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "40mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "95mm", "55mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    // FBTITLE("住所",115,164.5)

    // LODOP.ADD_PRINT_TEXT("115mm","191.5mm","75.5mm","40mm",`${data.dom}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
  // 合伙企业法人营业执照正本
  YYZZZB4: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    // ZBTITLE("名称", 134, 39)
    ZBTLONEITLE("名称", 134, 35)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("出资额", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    // ZBTITLE("类型", 146, 39)
    ZBTLONEITLE("类型", 146, 35)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("成立日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    // ZBTITLE("执行事务合伙人",158,39)
    ZBTLONEITLE("执行事务合伙人", 158, 35)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "100mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("主要经营场所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    // ZBTITLE("经营范围", 170, 39)
    ZBTLONEITLE("经营范围", 178, 35)

    LODOP.ADD_PRINT_TEXT("178mm", "82mm", "130mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }

    printZBEvt(data, qrcode)
  },
  // 合伙企业法人营业执照副本
  YYZZFB4: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("出资额", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)

    // LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.estdate}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("执行事务合伙人", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "58mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("主要经营场所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "95mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
  // 农民专业合作社法人营业执照正本
  YYZZZB6: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTLONEITLE("出资额", 134, 229)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTLONEITLE("成立日期", 146, 229)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("法定代表人", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTLONEITLE("住所", 158, 229)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("业务范围", 170, 39)

    LODOP.ADD_PRINT_TEXT("170mm", "82mm", "130mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }

    printZBEvt(data, qrcode)
  },
  // 农民专业合作社法人营业执照副本
  YYZZFB6: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    // FBTITLE("成员出资总额",85,164.5)
    FBTITLE("出资额", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)

    // LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.estdate}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("法定代表人", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("住所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "95mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
  // 个人独资企业营业执照正本
  YYZZZB7: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("出资额", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("成立日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);


    ZBTITLE("投资人", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("住所", 158, 233)


    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("经营范围", 170, 39)

    LODOP.ADD_PRINT_TEXT("170mm", "82mm", "130mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }

    printZBEvt(data, qrcode)
  },
  // 个人独资企业营业执照副本
  YYZZFB7: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("出资额", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)

    // LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.estdate}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);



    FBTITLE("投资人", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("住所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "95mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
  // 内资非公司企业营业执照正本
  YYZZZB3: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("负责人", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    // ZBTLONEITLE("营业期限", 146, 229)

    // LODOP.ADD_PRINT_TEXT("146mm","276mm","130mm","30mm",`${data.jyqx}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("成立日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    // ZBTITLE("负责人",158,39)

    // LODOP.ADD_PRINT_TEXT("158mm","82mm","130mm","30mm",`${data.lerep}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("经营范围", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }

    ZBTITLE("经营场所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    printZBEvt(data, qrcode)
  },
  // 内资非公司企业营业执照副本
  YYZZFB3: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);


    FBTITLE("负责人", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)

    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    //     FBTITLE("营业期限",95,164.5)
    // // jyqx
    //     LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.jyqx}`);
    //     LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    //     LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);


    // FBTITLE("负责人",105,29)

    // LODOP.ADD_PRINT_TEXT("105mm","58mm","95mm","20mm",`${data.lerep}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("经营范围", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    FBTITLE("经营场所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
  // 外资公司营业执照正本
  YYZZZB11: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("成立日期", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("营业期限", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.jyqx}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("负责人", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("营业场所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("经营范围", 170, 39)

    LODOP.ADD_PRINT_TEXT("170mm", "82mm", "130mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }

    printZBEvt(data, qrcode)
  },
  // 外资公司营业执照副本
  YYZZFB11: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("85mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("85mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("85mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("85mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("85mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("营业期限", 95, 164.5)

    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.jyqx}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("负责人", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("营业场所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "95mm", "55mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    printFBEvt(data, qrcode)
  },
  // 农民合作营业执照正本
  YYZZZB15: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("出资额", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("成立日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("法定代表人", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("住所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "30mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("经营范围", 170, 39)

    LODOP.ADD_PRINT_TEXT("170mm", "82mm", "130mm", "70mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }

    printZBEvt(data, qrcode)
  },
  // 农民合作营业执照副本
  YYZZFB15: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("出资额", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.regcap}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)

    // LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.estdate}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("法定代表人", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("住所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "40mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "95mm", "55mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
  // 个体工商户营业执照正本打印
  YYZZZB8: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "420mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    // 上 -6 左 -2
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "30mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("组成形式", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "30mm", "个人经营");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "30mm", "个体工商户");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("注册日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "30mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("经营者", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "30mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("经营场所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "50mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");


    ZBTITLE("经营范围", 170, 39)

    LODOP.ADD_PRINT_TEXT("170mm", "82mm", "130mm", "70mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }
    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP5200");
    // LODOP.SET_PRINTER_INDEX("3208d0201");
    // LODOP.PRINT();
    printZBEvt(data, qrcode)
  },
  // 个体工商户营业执照正本打印
  YYZZFB8: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");
    //  顶部距离 左侧距离  宽度 高度
    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("组成形式", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", "个人经营");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", "个体工商户");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("注册日期", 95, 164.5)

    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("经营者", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("经营场所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "40mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    FBTITLE("经营范围", 115, 29)

    LODOP.ADD_PRINT_TEXT("115mm", "58mm", "95mm", "55mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
  // 农民专业合作社分支机构营业执照正本
  YYZZZB155: (data, qrcode) => {
    LODOP.PRINT_INITA("0mm", "0mm", "420mm", "297mm", "");
    // LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A3");
    //  顶部距离 左侧距离  宽度 高度
    ZBTITLE("名称", 134, 39)

    LODOP.ADD_PRINT_TEXT("134mm", "82mm", "130mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("负责人", 134, 233)

    LODOP.ADD_PRINT_TEXT("134mm", "276mm", "130mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("类型", 146, 39)

    LODOP.ADD_PRINT_TEXT("146mm", "82mm", "130mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");

    ZBTITLE("成立日期", 146, 233)

    LODOP.ADD_PRINT_TEXT("146mm", "276mm", "130mm", "20mm", `${data.estdate}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    ZBTITLE("经营范围", 158, 39)

    LODOP.ADD_PRINT_TEXT("158mm", "82mm", "130mm", "100mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    // LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-2.32mm");
    if (data.opscope.length < 340) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    } else if (data.opscope.length < 400) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    }
    else if (data.opscope.length < 460) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    }
    else if (data.opscope.length < 575) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    }
    ZBTITLE("经营场所", 158, 233)

    LODOP.ADD_PRINT_TEXT("158mm", "276mm", "110.5mm", "100mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);

    printZBEvt(data, qrcode)
  },
  // 农民专业合作社分支机构营业执照副本
  YYZZFB155: (data, qrcode) => {
    // LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "210mm", "");
    // LODOP.PRINT_INITA("-4mm","-5mm","297mm","210mm","");
    // LODOP.SET_PRINT_PAGESIZE(2, "297mm", "210mm", "");
    LODOP.SET_PRINT_PAGESIZE(2, "", "", "A4");

    FBTITLE("名称", 85, 29)

    LODOP.ADD_PRINT_TEXT("85mm", "58mm", "95mm", "20mm", `${data.entname}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("负责人", 85, 164.5)

    LODOP.ADD_PRINT_TEXT("85mm", "193mm", "75.5mm", "20mm", `${data.lerep}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("类型", 95, 29)

    LODOP.ADD_PRINT_TEXT("95mm", "58mm", "95mm", "20mm", `${data.enttypeCn}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("成立日期", 95, 164.5)

    // LODOP.ADD_PRINT_TEXT("95mm","193mm","75.5mm","20mm",`${data.estdate}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    LODOP.ADD_PRINT_TEXT("95mm", "193mm", "75.5mm", "20mm", `${data.estdate.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "201.5mm", "75.5mm", "20mm", '年');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "208.5mm", "75.5mm", "20mm", `${data.estdate.slice(7, 9)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "215.5mm", "75.5mm", "20mm", '月');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "221mm", "75.5mm", "20mm", `${data.estdate.slice(12, 14)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    LODOP.ADD_PRINT_TEXT("95mm", "227.5mm", "75.5mm", "20mm", '日');
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);

    FBTITLE("经营范围", 105, 29)

    LODOP.ADD_PRINT_TEXT("105mm", "58mm", "95mm", "55mm", `${data.opscope}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1.5mm");

    FBTITLE("经营场所", 105, 164.5)

    LODOP.ADD_PRINT_TEXT("105mm", "193mm", "75.5mm", "40mm", `${data.dom}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10.5);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");
    if (data.opscope.length < 350) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    } else if (data.opscope.length < 420) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    }
    else if (data.opscope.length < 560) {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    }
    else {
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
    }
    // FBTITLE("经营范围",115,29)

    // LODOP.ADD_PRINT_TEXT("115mm","58mm","95mm","55mm",`${data.opscope}`);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","汉仪书宋二简");
    // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.SET_PRINT_STYLEA(0,"LineSpacing","-1.5mm");

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("3208d0202");
    // LODOP.PRINT();
    printFBEvt(data, qrcode)
  },
};
export default lodop;
